<form class="w-100 h-100 form" [formGroup]="Form" (ngSubmit)="emit()" *ngIf="data && states">
  <h4 class="text-center">Edición de estado de solicitud</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12">
      <p style="font-size: 20px">El Estado actual de esta solicitud <b>{{data['statusId']}}</b></p>
      <h5>Puede seleccionar un nuevo estado para la solicitud</h5>
    </div>
    <div class="col-12 mb-5">
      <mat-button-toggle-group formControlName="statusId">
        <mat-button-toggle [value]="tag.id" *ngFor="let tag of states">{{tag.name}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Comentario</mat-label>
        <textarea matInput formControlName="comment" placeholder="comentario"></textarea>
        <mat-error>Este campo es <b>Requerido</b></mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="Form.invalid">
      <ng-template
        [ngIf]="(Form.get('comment').dirty && Form.get('comment').value) && (Form.get('comment').value !==  this.data['request']['message'])"
        [ngIfElse]="defaultMessage">
        Guardar
        <!-- Guardar comentario -->
      </ng-template>
      <ng-template #defaultMessage>
        Guardar
        <!-- Guardar con nuevo estado -->
      </ng-template>
    </button>
  </div>
</form>
